module.exports = __webpack_public_path__ + "static/media/release_updates.e3208c3d.svg";